<template>
  <div class="card floating">
    <div class="card-title">
      <h2>{{ $t("prompts.makenotes") }}</h2>
    </div>
    <div class="card-content">
      <!-- insert box for upload notes  store alongside
    with username_date_code encoding -->
      <notes />
    </div>
    <div class="card-action">
      <button
        class="button button--flat button--grey"
        @click="$store.commit('closeHovers')"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')"
      >
        {{ $t("buttons.cancel") }}
      </button>
      <button
        @click="(event) => showConfirm(event)"
        class="button button--flat"
        type="submit"
        :aria-label="$t('buttons.save')"
        :title="$t('buttons.save')"
      >
        {{ $t("buttons.save") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import notes from "./Notes";
export default {
  name: "makenotes",
  components: {
    notes,
  },
  computed: mapState(["showConfirm"]),
  methods: {
    uploadFile: function () {
      let textNotes = this.$store.state.textNotes;
      console.log("Upload found textnotes = " + textNotes);
      document.getElementById("upload-input").value = "";
      document.getElementById("upload-input").click();
    },
    uploadFolder: function () {
      document.getElementById("upload-folder-input").value = "";
      document.getElementById("upload-folder-input").click();
    },
  },
};
</script>
